<template>
  <div>
    <!-- Loading State -->
    <div
      v-if="isLoading"
      class="mx-auto flex items-center justify-center h-20"
    >
      <transition name="fade">
        <Icon type="loading-spinner" />
      </transition>
    </div>

    <!-- Error State -->
    <div
      v-else-if="error"
      class="bg-red-50 border border-red-200 rounded-lg p-6"
    >
      <div class="flex items-start space-x-4">
        <div class="flex-shrink-0">
          <Icon
            type="exclamation-triangle"
            class="h-8 w-8 text-red-600"
          />
        </div>
        <div>
          <h3 class="text-lg font-semibold text-red-800 mb-2">
            Error Loading Domain Info
          </h3>
          <p class="text-red-700">
            Unable to load custom domain information. Please try again later.
          </p>
        </div>
      </div>
    </div>

    <!-- Domain Setup Status -->
    <div
      v-else-if="hasCustomDomains"
    >
      <div class="bg-success border flex border-green-200 rounded-lg p-3 text-green-700">
        <div class="flex-shrink-0 mr-2">
          <Icon
            type="check-circle"
            class="h-5 w-5 mt-0.5"
          />
        </div>
        <p class="mb-0 mt-0.5">
          Your custom domain is currently active
        </p>
      </div>
      <div
        v-for="domain in domainData.customDomains"
        :key="domain"
      >
        <div class="relative mt-4 mb-4 flex items-center space-x-2">
          <input
            :value="domain"
            class="w-full p-2 border border-gray-300 rounded-lg bg-muted h-10"
            readonly
            disabled
          >
          <CopyButton
            :text-to-copy="domain"
            class="w-[200px]"
            button-text="Copy Link"
          />
        </div>
        <p class="mb-4">
          This is the link users can use to access your Live App
        </p>
        <a
          class="inline-block mb-4 p-3 rounded-lg border border-solid border-default bg-white
          hover:bg-brand-50 hover:border-brand-600 text-emphasis text-base font-medium"
          target="_blank"
          rel="noreferrer"
          :href="constants.REQUEST_URL"
        >
          Request Change
        </a>
        <a
          class="text-subtle hover:text-default underline flex items-center"
          target="_blank"
          rel="noreferrer"
          :href="constants.LEARN_MORE_URL"
        >
          <span>Learn more about app URL structures</span>
          <Icon
            type="arrow-top-right-thick"
            class="h-4 w-4 ml-2 top-1"
          />
        </a>
      </div>
    </div>

    <!-- Domain Not Setup -->
    <div
      v-else
    >
      <p>
        Custom domains are available on your Plan.
        Submit a request and our Support team will contact you to assist with the setup.
      </p>

      <a
        class="button save bg-gradient-primary rounded-lg border-0 p-3 text-base leading-4 font-medium"
        target="_blank"
        rel="noreferrer"
        :href="constants.REQUEST_URL"
      >
        Request Custom Domain
      </a>

      <a
        class="text-subtle hover:text-default underline mt-4 flex items-center"
        target="_blank"
        rel="noreferrer"
        :href="constants.LEARN_MORE_URL"
      >
        <span>Learn more about customizing your app URL</span>
        <Icon
          type="arrow-top-right-thick"
          class="h-4 w-4 ml-2 top-1"
        />
      </a>
    </div>
  </div>
</template>

<script>
import CopyButton from '@/components/ui/CopyButton';
import Icon from '@/components/ui/Icon.vue';
import CustomDomainUtils from '@/components/settings/custom-domains/CustomDomainUtils';

export default {
  name: 'CustomDomainPro',
  components: {
    Icon,
    CopyButton,
  },
  mixins: [
    CustomDomainUtils,
  ],
  async mounted() {
    await this.fetchCustomDomains();
  },
};
</script>

<style scoped>
</style>
